import { useEffect } from 'react';
import Card from '@/components/Card';
import { Button } from '@/components/Button';
import { Input } from '@/components/Controls/Input';
import { Switch } from '@/components/Controls/Switch';
import { FormField } from '@/components/Form/FormField';
import { FieldValues, Path } from 'react-hook-form';
import { FormManagementProps } from '@/type/form.types';
import { TitleSection } from '@/components/Header/Section/TitleSection';

export const GeneralSettingInfosManagement = <TSchema extends FieldValues>({
  t,
  data,
  watch,
  register,
  setValue,
  errors,
  submitDisabled,
  onSubmit,
}: FormManagementProps<TSchema>) => {
  /**
   * === Set Value Watchers section ===
   */
  const activeValue = watch && watch('active' as Path<TSchema>);
  /**
   * === END OF Set Value Watchers section ===
   */

  /**
   * === Set Fields Initial Values section ===
   */
  useEffect(() => {
    if (setValue && data) {
      setValue('token' as Path<TSchema>, data.token ?? '');
      setValue('active' as Path<TSchema>, data.active);
    }
  }, [setValue, data]);
  /**
   * === END OF Set Fields Initial Values section ===
   */

  return (
    <form onSubmit={onSubmit}>
      <Card
        title={
          <TitleSection
            defaultIconClassName="-mt-0.75 ki-setting-2"
            textClassName="flex flex-1 font-normal"
            text={
              <div className="flex flex-1 items-center gap-5">
                <div className="flex flex-1 font-semibold">
                  {t('generalSettings')}
                </div>
              </div>
            }
          />
        }
        footer={
          <Button
            buttonClassName="px-8"
            text={
              submitDisabled ? `${t('common:loading')}...` : t('common:confirm')
            }
            disabled={submitDisabled}
          />
        }
        bodyClassName="py-8 flex flex-col gap-8"
      >
        <>
          <FormField
            text={t('activateAutomatedEmailing')}
            textWrapperClassName="mt-3"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5 mt-3">
              <Switch
                {...(register && register('active' as Path<TSchema>))}
                errorMessage={errors && (errors.active?.message as string)}
                checked={data ? activeValue : true}
              />
            </div>
          </FormField>
          <FormField
            text={t('brevoApiToken')}
            required
            textWrapperClassName="mt-3"
          >
            <div className="flex flex-1 flex-wrap items-start gap-5">
              <Input
                {...(register && register('token' as Path<TSchema>))}
                errorMessage={errors && (errors.token?.message as string)}
                placeholder={t('brevoApiToken')}
                type="text"
                autoComplete="off"
                style={{ WebkitTextSecurity: 'disc' } as React.CSSProperties}
              />
            </div>
          </FormField>
        </>
      </Card>
    </form>
  );
};
